import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingBottom: ({ disableBottomPadding }) =>
      disableBottomPadding ? '0' : '2rem'
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.lg,
    padding: ({ isSmall }) => (isSmall ? '1.75rem 0 0 0' : '3.5rem 0 0 3.5rem'),

    '& .icon': {
      cursor: 'pointer',
      margin: '0 0.5rem',
      width: '1rem',
      height: '1rem'
    }
  }
}))

export default useStyles
